import { createDefaultMediaError, MediaDeviceError } from "@/agora/utils";

export enum VideoCallingQuality {
  "180p_4" = "180p_4",
  "240p_1" = "240p_1",
  "360p_1" = "360p_1",
  "480p_1" = "480p_1",
  "720p_1" = "720p_1",
}

export interface CallingState {
  callingUserIds: string[];
  videoUserIds: string[];
  audioUserIds: string[];
  enabledAgoraNoiseCancelling: boolean;
  postLocalUserReconnectedIntervalId?: number;
  cameraError: MediaDeviceError;
  microphoneError: MediaDeviceError;
  speakerError: MediaDeviceError;
  isJoinedSession: boolean;
  videoCallingQuality: VideoCallingQuality;
}

export const DEFAULT_NOISE_CANCELLING_ENABLED = true;
export const DEFAULT_VIDEO_CALLING_QUALITY = VideoCallingQuality["240p_1"];

export const initCallingModuleState = () => ({
  callingUserIds: [],
  videoUserIds: [],
  audioUserIds: [],
  enabledAgoraNoiseCancelling: DEFAULT_NOISE_CANCELLING_ENABLED,
  postLocalUserReconnectedIntervalId: undefined,
  cameraError: createDefaultMediaError(),
  microphoneError: createDefaultMediaError(),
  speakerError: createDefaultMediaError(),
  isJoinedSession: false,
  videoCallingQuality: DEFAULT_VIDEO_CALLING_QUALITY,
});

const state: CallingState = initCallingModuleState();

export default state;
